import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { SearchExportProvider } from './context/SearchExportContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <SearchExportProvider>
      <App />
    </SearchExportProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
